$(function () {

    $(".counter").counterUp();

});
